import type { BackupRepository } from '../../../application/ports/BackupRepository';
import type { BackupMetadata } from '../../../domain/backup/BackupMetadata';
import type { BackupMetadataId, ProfileId } from '../../../domain/shared/ids';
import type { AscendInvictusDatabase } from '../AscendInvictusDatabase';
import { BackupMetadataMapper } from '../mappers';
import { executePersistence } from '../translatePersistenceError';

export class DexieBackupRepository implements BackupRepository {
  public constructor(private readonly database: AscendInvictusDatabase) {}

  public save(metadata: BackupMetadata): Promise<void> {
    return executePersistence('write', async () => {
      await this.database.backupMetadata.put(BackupMetadataMapper.toRecord(metadata));
    });
  }

  public latest(profileId: ProfileId): Promise<BackupMetadata | null> {
    return executePersistence('read', async () => {
      const records = await this.database.backupMetadata
        .where('profileId')
        .equals(profileId)
        .toArray();
      const latest = records.toSorted((left, right) =>
        right.createdAt.localeCompare(left.createdAt),
      )[0];
      return latest ? BackupMetadataMapper.fromRecord(latest) : null;
    });
  }

  public delete(id: BackupMetadataId): Promise<void> {
    return executePersistence('write', async () => {
      await this.database.backupMetadata.delete(id);
    });
  }

  public clearForProfile(profileId: ProfileId): Promise<void> {
    return executePersistence('write', async () => {
      await this.database.backupMetadata.where('profileId').equals(profileId).delete();
    });
  }
}
